export default {
  lifespan: 250,
  size: 2,
  speed: 2,
  radiusNoise: 40,
  connect: 20,
};
